import { userConstants } from "../../constant";

export function advert(state = [], action) {
  const { advert, type } = action;
  switch (type) {
    case userConstants.GET_ADVERT:
      return advert;
    default:
      return state;
  }
}
